import React from 'react';

import {LabelFlair} from 'comp/flairs';

import classNames from 'classnames';

const InputGroup = (props) => (
  <div className={classNames('input-group', props.class)}>
    <label className='input-title'>
      {props.title}
      {props.newTag ? <LabelFlair>NEW!!</LabelFlair> : null}
    </label>
    {props.children}
  </div>
);

InputGroup.propTypes = {
  title: React.PropTypes.string,
  newTag: React.PropTypes.bool,
  class: React.PropTypes.string,
  children: React.PropTypes.node
};

export default InputGroup;



// WEBPACK FOOTER //
// ./src/ui/inline-text/input-group.jsx